// eslint-disable-next-line no-unused-vars
import { React, useState, useEffect} from "react";
import {
	AddproductWrapper,
	Title,
	AddButtonGroup,
} from "../ProductsPage.styled";
import AddProductForm from "../Forms/AddProductForm";
import Parse from "../../../api/ApiConfig";
import { toast } from "react-toastify";
import Tooltip from "@mui/material/Tooltip";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import { GrPrevious, GrNext } from "react-icons/gr";
import { useDispatch } from "react-redux";
import { setLoadingState } from "../../../redux/AppSlice";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { randomId } from "../../../utils/Utils";


function AddProducts() {
	//refactor and use redux
	// const [productName, setProductName] = useState("Input product name here");
	// const [productPrice, setProductPrice] = useState("Price");
	const dispatch = useDispatch();
	const [parseFile, setParseFile] = useState("");
	const [secondParseFile, setSecondParseFile] = useState('')
	const [thirdParseFile, setThirdParseFile] =useState("")
	const [firstImage, setFirstImage] = useState("");
	const [secondImage, setSecondImage] = useState("");
	const [thirdImage, setThirdImage] = useState("");

	useEffect(() => {
		const swiper = document.querySelector(".addSwiper").swiper;
		let next = document.getElementById("next");
		next.addEventListener("click", () => {
			swiper.slideNext(800);
		});

		let prev = document.getElementById("prev");
		prev.addEventListener("click", () => {
			swiper.slidePrev(800);
		});
	}, []);

	let imageFile;
	const handleImageUpload = (event, position) => {
		if (position === "first") {
			const file = event.target.files[0];
			const reader = new FileReader();
			reader.onload = () => {
				setFirstImage(reader.result);
			};
			if (file) {
				// console.log(file)
				reader.readAsDataURL(file);
				saveImageToParse(file, position);
			}
		} else if (position === "second") {
			const file = event.target.files[0];
			const reader = new FileReader();
			reader.onload = () => {
				setSecondImage(reader.result);
			};
			if (file) {
				reader.readAsDataURL(file);
				saveImageToParse(file, position)
			}
		} else {
			const file = event.target.files[0];
			const reader = new FileReader();
			reader.onload = () => {
				setThirdImage(reader.result);
			};
			if (file) {
				reader.readAsDataURL(file);
				saveImageToParse(file, position)
			}
		}
	};



	const saveImageToParse = async(file,position)=>{
		// console.log(file.name)
		dispatch(setLoadingState(true));
		try {
			const fileExtension = file?.name?.slice((file?.name?.lastIndexOf(".") - 1 >>> 0) + 2);
			const uniqueId = randomId()
			const generatedFileName = `${uniqueId}.${fileExtension}`
			imageFile = new Parse.File(generatedFileName, file);
			await imageFile.save();
			dispatch(setLoadingState(false));
			toast.success("Image Saved");
			if(position === 'first'){
				setParseFile(imageFile);
			}
			else if(position === 'second'){
				setSecondParseFile(imageFile)
			}
			else{
                setThirdParseFile(imageFile)
			} 
			
		} catch (error) {
			dispatch(setLoadingState(false));
			toast.error(
				"unable to save image, please check your internet connection and try again later",
				error
			);
			if(position === 'first'){
				setFirstImage('');
			}
			else if(position === 'second'){
				setSecondImage('');
			}
			else{
				setThirdImage(''); 
			} 
			console.error("Error saving item:", error);
		}
	}

	return (
		<AddproductWrapper>
			<Title>Add new product</Title>

			<main>
				<div className='LeftSection'>
					<div className='productDetails'>
					<div className='buttons'>
							<button className="absolute-prev" id="prev">
								<GrPrevious size={28} />
							</button>
							<button className="absolute-next" id="next">
								<GrNext size={28} />
							</button>
						</div>
						<Swiper
							// navigation={true}
							modules={[Pagination, Autoplay, Navigation]}
							className='addSwiper'
							loop={true}
						>
							{[
								firstImage,
								secondImage,
								thirdImage,
							].map((url, index) => {
								return (
									<SwiperSlide key={index}>
										<img src={url || "/images/placeholder_img.jpg"} />
									</SwiperSlide>
								);
							})}
						</Swiper>
						{/* <p className='name'>{productName}</p>
						<p className='price'>
							{" "}
							{productPrice === "Price"
								? productPrice
								: getFormattedAmount.format(productPrice)}
						</p> */}
					</div>
					<AddButtonGroup>
						<Tooltip title='Upload primary image' arrow>
							<label htmlFor='image'>
								<img
									className=''
									style={{width: "60px", height: "60px" }}
									src={firstImage || "/images/placeholder_img.jpg"}
									alt='import button'
								/>

								<input
									type='file'
									accept='image/*'
									name='image'
									id='image'
									onChange={(e)=>handleImageUpload(e, 'first')}
								/>
							</label>
						</Tooltip>

						<Tooltip title='Upload secondary image' arrow>
							<label htmlFor='image2' className='test'>
								<img
									className=''
									style={{width: "60px", height: "60px" }}
									src={secondImage || "/images/placeholder_img.jpg"}
									alt='import button'
								/>

								<input
									type='file'
									accept='image/*'
									name='image'
									id='image2'
									onChange={(e)=>handleImageUpload(e, 'second')}
								/>
							</label>
						</Tooltip>

						<Tooltip title='Upload Image' arrow>
							<label htmlFor='image3' className='test'>
								<img
									className=''
									style={{width: "60px", height: "60px" }}
									src={thirdImage || "/images/placeholder_img.jpg"}
									alt='import button'
								/>

								<input
									type='file'
									accept='image/*'
									name='image'
									id='image3'
									onChange={(e)=>handleImageUpload(e, 'third')}
								/>
							</label>
						</Tooltip>
					</AddButtonGroup>

					
				</div>

				<div className='productForm'>
					<AddProductForm
						parseFile={parseFile}
						secondProductImage = {secondParseFile}
						thirdProductImage = {thirdParseFile}
						setFirstImage = {setFirstImage}
						setSecondImage = {setSecondImage}
						setThirdImage = {setThirdImage}
					/>
				</div>
			</main>
		</AddproductWrapper>
	);
}

export default AddProducts;
